const BASE_URL = import.meta.env.VITE_BASE_URL || 'https://api.acttstudy.org';
const FRONTEND_BASE_URL = import.meta.env.VITE_FRONTEND_BASE_URL || 'https://www.acttstudy.org';
const UPSTREAM_URL = import.meta.env.VITE_UPSTREAM_URL || 'http://push.acttstudy.org';

export { BASE_URL, UPSTREAM_URL, FRONTEND_BASE_URL };
